import React from 'react';
import { injectIntl } from 'react-intl';

import FormSwitchery from 'components/forms/FormSwitchery';

class ShareableInit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mayBeShared: props.mayBeShared !== undefined ? props.mayBeShared : true,
      shareWithCompany: props.shareWithCompany !== undefined ? props.shareWithCompany : true,
      shareWithHolding: props.shareWithHolding !== undefined ? props.shareWithHolding : true,
    };
  }

  componentDidMount = () => {
    this.onSettingsChanged();
  };

  onSettingsChanged = () => {
    const { onChange } = this.props;
    const { mayBeShared, shareWithCompany, shareWithHolding } = this.state;

    if (onChange) {
      onChange({
        mayBeShared,
        shareWithCompany,
        shareWithHolding,
      });
    }
  };

  onChange = (name, value) => {
    this.setState({ [name]: value }, this.onSettingsChanged);
  };

  render() {
    const {
      intl: { messages },
      disabled,
    } = this.props;
    const { mayBeShared, shareWithCompany, shareWithHolding } = this.state;

    return (
      <>
        <p className="m-t-10 form-group-title">{messages.share}</p>
        <div className="form-group-attached m-b-10">
          <div className="form-group form-group-default padding-10">
            <FormSwitchery
              name="mayBeShared"
              label={messages.allow_others_to_share}
              checked={mayBeShared}
              value
              onChange={this.onChange}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="form-group-attached">
          <div className="form-group form-group-default padding-10">
            <FormSwitchery
              name="shareWithCompany"
              label={messages.share_with_the_company_i_work_for}
              checked={shareWithCompany}
              value
              onChange={this.onChange}
              disabled={disabled}
            />
          </div>
          <div class="form-group form-group-default padding-10">
            <FormSwitchery
              name="shareWithHolding"
              label={messages.share_with_all_companies_in_my_holding_structure}
              checked={shareWithHolding}
              value
              onChange={this.onChange}
              disabled={disabled}
            />
          </div>
        </div>
      </>
    );
  }
}

export default injectIntl(ShareableInit);
